module.exports = __webpack_public_path__ + "static/media/cake-fill-orange.d5fe82f7.svg";